import React from 'react';
import './App.css';
import { Navigate, Route, Routes } from "react-router-dom";
import ContextWrappers from './common/ContextWrappers';
import Navbar from "./layout/Navbar/Navbar";
import SideBar from "./layout/SideBar/SideBar";
import { Layout, Alert } from "antd";
import { getMenuItems, getPrivateRoutes, getDefaultPath } from "./routes";
import * as am4core from "@amcharts/amcharts4/core";
import { checkEnableTokenRefresh, refreshToken } from './utils/authservice';
import DashboardContext from './common/ContextWrappers/Dashboard/Context';
am4core.addLicense("CH297319641");

const SwitchRoutes = ({ appSettings }) => {
    const defaultPath = getDefaultPath(appSettings);
    return (
        <Routes>
            {getPrivateRoutes(appSettings)}
            <Route path="/" element={<Navigate to={defaultPath} replace />} />
        </Routes>
    );
};


class App extends React.Component {

    componentDidMount() {
        checkEnableTokenRefresh(refreshToken);
    }

    render() {
        return (
            <Layout style={{ height: "100%" }}>
                <ContextWrappers>
                    <DashboardContext.Consumer>
                        {({ isGlobalDashboard }) => {
                            const appSettings = {
                                "isGlobalDashboard": isGlobalDashboard,
                            };
                            return (
                                <>
                                    <Navbar />
                                    <Layout >
                                        <SideBar routes={getMenuItems(appSettings)} />
                                        <Layout.Content style={{ padding: "16px", overflow: "auto" }}>
                                            <Alert.ErrorBoundary>
                                                <SwitchRoutes appSettings={appSettings} />
                                            </Alert.ErrorBoundary>
                                        </Layout.Content>
                                    </Layout>
                                </>
                            );
                        }}
                    </DashboardContext.Consumer>
                </ContextWrappers>
            </Layout>
        );
    }
}

export default App;
